function parseItemLinks(col) {
  const links = col.querySelectorAll('a');
  let list = '';
  let classes = '';

  links.forEach((link) => {
    classes = link.classList.value;
    list += `<a href="${link.href}" class="link link--next ${classes}">${link.textContent}</a>`;
  });

  return list;
}

const ROOT_KEY = 'links-list';
const COLUMN_KEY = 'listcol';
let COMPONENT_INDEX = 0;

export default class LinksListComponent {
  init() {
    jQuery(ROOT_KEY).each((i, el) => {
      this.render(el);
    });

    return this;
  }

  /**
   * Renders List links row
   * @param {HTMLElement} root
   */
  render(root) {
    COMPONENT_INDEX = 1 + COMPONENT_INDEX;
    const xml = root.outerHTML;
    const dom = jQuery(
      `<div class="links-list" id="links-list--${COMPONENT_INDEX}">
         <div class="links-list__row"></div>
       </div>`,
    );

    const row = dom.find('.links-list__row');

    jQuery(xml)
      .children(COLUMN_KEY)
      .each((j, col) => {
        const links = parseItemLinks(col);
        const icon = col.getAttribute('icon');
        const title = col.getAttribute('title');

        row.append(`
          <div class="links-list__column">
            <div class="links-list__header">
							<i class="ico-${icon}"></i>					  
						  <span class="links-list__title">${title}</span>
						</div>
						${links}
          </div>
        `);
      });

    jQuery(root).replaceWith(dom);
  }
}
